import Input from './Input'
import TextArea from './TextArea'

export { Input, TextArea }
